import { render, staticRenderFns } from "./PTopBoard.vue?vue&type=template&id=00b27878&scoped=true&"
import script from "./PTopBoard.vue?vue&type=script&lang=ts&"
export * from "./PTopBoard.vue?vue&type=script&lang=ts&"
import style0 from "./PTopBoard.vue?vue&type=style&index=0&id=00b27878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b27878",
  null
  
)

export default component.exports